import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftcard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGiftcard"><Path d="M14.5 4.5V12M14.5 12V19.5M14.5 12L21.5 12M14.5 12L2.5 12M14.5 12L17.5 9M14.5 12L11.5 9M14.5 12L17.5 15M14.5 12L11.5 15M2.5 4.50002H21.5V19.5H2.5V4.50002Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGiftcard;
